var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert_icon_32x32",
    "data-name": "Alert icon 32x32",
    transform: "translate(-327 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_32x32",
    "data-name": "32x32",
    width: 32,
    height: 32,
    transform: "translate(327 361)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert_icon",
    "data-name": "alert icon",
    transform: "translate(333.996 368.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1.178,14.676l6.48-12.83a1.491,1.491,0,0,1,2.691,0l6.48,12.83a1.649,1.649,0,0,1-.046,1.56,1.5,1.5,0,0,1-1.3.761H2.523a1.5,1.5,0,0,1-1.3-.762A1.649,1.649,0,0,1,1.178,14.676Z",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y2: 4.571,
    transform: "translate(9.002 6.332)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1.091,
    cy: 1.143,
    rx: 1.091,
    ry: 1.143,
    transform: "translate(7.911 12.426)",
    fill: "gray"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.1ca2a2f7e3ed7e95a02ef1c99f8241e2.svg";
export { ForwardRef as ReactComponent };